import isNil from 'lodash/isNil';
import { connect } from 'react-redux';
import MobileView from '../../../MobileFinancialPlan/MobileInsurance/MobileLongTermCare/MobileLongTermCareView';
import { setReactCalibrationWidget, updateGoalViewState } from '../../FinancialPlanActions';
import { insuranceNotes } from '../NotesPopup/NotesPopupSelector';
import {
  selectedIndex as selectedOwnerIndex,
  selectedOwnerName,
} from '../OwnerDropdown/OwnerDropdownSelector';
import { getNote, getSubgoal } from './LongTermCareHelpers';
import View from './LongTermCareView';

const mapStateToProps = (state, ownProps) => {
  const selectedGoal = getSubgoal(ownProps.insuranceGoal);
  const ownerDropdownProps = {
    clientId: ownProps.clientId,
    goalId: ownProps.goalId,
    subgoalId: ownProps.selectedSection,
    spouseName: selectedGoal.LongTermCareInsurance.SpouseName,
    principalName: selectedGoal.LongTermCareInsurance.PrincipalName,
    selectedGoal,
  };
  return {
    selectedGoal,
    note: getNote(insuranceNotes(state, ownerDropdownProps)),
    subgoalData: selectedGoal.LongTermCareInsurance,
    subgoalId: ownProps.selectedSection,
    selectedOwnerIndex: !isNil(ownProps.selectedOwnerIndex)
      ? ownProps.selectedOwnerIndex
      : selectedOwnerIndex(state, ownerDropdownProps),
    selectedOwnerName: !isNil(ownProps.selectedOwnerName)
      ? ownProps.selectedOwnerName
      : selectedOwnerName(state, ownerDropdownProps),
  };
};

const mapDispatchToProps = dispatch => ({
  setReactCalibrationWidget: (calibration, clientId) => {
    dispatch(setReactCalibrationWidget(calibration, clientId));
  },
  setSelectedOwnerIndex: (clientId, goalId) => ownerIndex => event => {
    dispatch(
      updateGoalViewState(goalId, clientId, {
        ownerIndex,
      }),
    );
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
export const MobileLongTermCare = connect(mapStateToProps, mapDispatchToProps)(MobileView);
